import { Component, OnInit } from '@angular/core';
import { Globals } from '../globals';
import { AuthService } from '../_services/auth.service';

@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss']
})
export class MainMenuComponent implements OnInit {

  constructor(
    public globals: Globals,
    public authService: AuthService
  ) { }

  ngOnInit(): void {
  }
}
